'use strict';
import { environment } from '@environments/environment';
printSendPurchaseOrderController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'$interval',
	'dialogHelper',
	'purchaseOrderSetupService',
	'purchaseOrderService',
	'authInterceptorService',
	'authService',
	'USER_CLAIMS',
	'PURCHASING_TYPES',
];
angular.module('schoolLinqApp').controller('printSendPurchaseOrderController', printSendPurchaseOrderController);

function printSendPurchaseOrderController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	$interval,
	dialogHelper,
	purchaseOrderSetupService,
	purchaseOrderService,
	authInterceptorService,
	authService,
	USER_CLAIMS,
	PURCHASING_TYPES
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.$watch(
		'vm.filteredPurchaseOrders',
		function (purchaseOrders) {
			var selectedItems = 0;
			var totalItems = 0;
			$scope.vm.filter.numberOfSelectedItemsPrint = 0;
			$scope.vm.filter.numberOfSelectedItemsEmail = 0;
			for (var index = 0; index < purchaseOrders.length; index++) {
				if (purchaseOrders[index].Status === $scope.vm.statusEnum.AwaitingSend) {
					totalItems++;
				}

				if (purchaseOrders[index].Selected && purchaseOrders[index].Status === $scope.vm.statusEnum.AwaitingSend) {
					selectedItems++;

					if (purchaseOrders[index].DeliveryMethod === 'Print') {
						$scope.vm.filter.numberOfSelectedItemsPrint++;
					} else {
						$scope.vm.filter.numberOfSelectedItemsEmail++;
					}
				}
			}

			$scope.vm.filter.numberOfSelectedItems = selectedItems;
		},
		true
	);

	$scope.loadingPromise = $q.all([$scope.vm.loadNumberOfCopies($scope.vm), $scope.vm.loadPurchaseOrders($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			numberOfCopies: null,
			purchaseOrders: [],
			filteredPurchaseOrders: [],
			filter: {
				search: '',
				status: 'Not Printed/Emailed',
				deliveryMethod: 'All',
				includeCheckRequests: false,
				numberOfSelectedItems: 0,
				numberOfSelectedItemsPrint: 0,
				numberOfSelectedItemsEmail: 0,
				allSelected: true,
				propertyName: 'PONumber',
				reverse: false,
				purchasingType: PURCHASING_TYPES.PurchaseOrder,
			},
			viewPurchaseOrder: {
				selectedCopyNumber: 1,
				images: [],
				activeImage: 0,
				printVendorCopy: false,
				printCopyTwo: false,
				printCopyThree: false,
				emailVendorCopy: false,
				emailReceiptCopy: false,
			},
			barLimit: 12,
			startIndex: 0,
			printVendorCopy: false,
			printCopyTwo: false,
			printCopyThree: false,
			emailVendorCopy: false,
			emailReceiptCopy: false,
			purchasingTypes: [
				{ id: 1, description: 'Requisition' },
				{ id: 2, description: 'Purchase Order' },
			],
			statusEnum: {
				AwaitingSend: 'Not Printed/Emailed',
				Sent: 'Printed/Emailed',
			},
			deliveryMethodEnum: {
				Print: 'Print',
				Email: 'Email',
				All: 'All',
			},
			deliveryMethods: [],
			statusList: [],
			sendStatus: [],
			sendStatusEmailsFailed: 0,
			sendStatusPrintsFailed: 0,
			sendStatusBarLimit: 12,
			sendStatusStartIndex: 0,
			errors: null,
			confirmPrintError: null,
			confirmEmailError: null,
			siteAccounting: authService.authentication.siteAccounting,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'PrintSendPOs', 'purchasing'),
		};

		function filterPurchaseOrders(model, purchaseOrder) {
			if (
				purchaseOrder.Status === model.filter.status &&
				(purchaseOrder.DeliveryMethod === model.filter.deliveryMethod || model.filter.deliveryMethod === model.deliveryMethodEnum.All)
			) {
				if (model.filter.includeCheckRequests === false) return !purchaseOrder.CheckRequest;
				return true;
			} else {
				return false;
			}
		}

		function openPuchaseOrder(model, purchaseOrderId, purchaseOrderSiteId) {
			$uibModal
				.open({
					windowClass: 'poPrintModal',
					template: require('@ajs/templates/fund/payable/purchaseorder-emailprint-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$q',
						'$uibModalInstance',
						'purchaseOrderService',
						function ($scope, $q, modalInstance, purchaseOrderService) {
							$q.all([getPreview($scope.vm), getPOSetupInfo($scope.vm)]);

							function getPreview(model) {
								$scope.vm.viewPurchaseOrder.purchasingType = $scope.vm.filter.purchasingType;

								$scope.gettingPreviewPromise = purchaseOrderService
									.getPurchaseOrderImagePreview(purchaseOrderId, $scope.vm.viewPurchaseOrder.selectedCopyNumber)
									.then(_.partial(finishedGettingPreview, model));

								function finishedGettingPreview(model, response) {
									$scope.vm.viewPurchaseOrder.images = response.data.images;
									$scope.vm.viewPurchaseOrder.activeImage = 0;
									return angular.noop;
								}
							}

							function getPOSetupInfo(model) {
								$scope.gettingPreviewPromise = purchaseOrderService
									.getPOSetupInfo(purchaseOrderId)
									.then(_.partial(finishedGettingPOSetupInfo, model));

								function finishedGettingPOSetupInfo(model, response) {
									$scope.vm.numberOfCopies = response.data.setupInfo.NumberOfCopies;
									$scope.vm.emailReceiptCopyNumber = response.data.setupInfo.EmailReceiptCopyNumber;
									$scope.vm.availableCopies = [
										{
											v: 1,
											n: 'Vendor Copy',
										},
									];
									if ($scope.vm.numberOfCopies > 1) {
										$scope.vm.availableCopies.push({
											v: 2,
											n: 'Copy 2',
										});
									}
									if ($scope.vm.numberOfCopies > 2) {
										$scope.vm.availableCopies.push({
											v: 3,
											n: 'Copy 3',
										});
									}

									return angular.noop;
								}
							}

							angular.extend($scope, {
								getPreview: _.partial(getPreview, model),
								cancel: function () {
									modalInstance.close(true);
								},
								sendEmail: function () {
									var purchaseOrderToSend = [
										{
											Id: purchaseOrderId,
											SiteId: purchaseOrderSiteId,
											Copy1: $scope.vm.viewPurchaseOrder.emailVendorCopy,
											Copy2: $scope.vm.viewPurchaseOrder.emailReceiptCopy,
										},
									];

									if (!$scope.vm.viewPurchaseOrder.emailVendorCopy && !$scope.vm.viewPurchaseOrder.emailReceiptCopy) {
										return;
									}

									$scope.emailPromise = purchaseOrderService.emailPurchaseOrder(purchaseOrderToSend).then(function (response) {
										if (response.data.numberFailed > 0) {
											//$scope.vm.errors = "The Purchase Order failed to send via Email.";
											$scope.vm.errors = response.data.failErrors.join();
										}

										modalInstance.close(true);
									});
								},
								print: function () {
									$scope.isReportFinished = false;
									$scope.loadingPromise = $scope.reportInterval = $interval(function () {
										if ($scope.isReportFinished) {
											$interval.cancel($scope.reportInterval);
											$scope.isReportFinished = false;
										}
									}, 1000);

									var purchaseOrderToPrint = [
										{
											Id: purchaseOrderId,
											Copy1:
												$scope.vm.filter.purchasingType === PURCHASING_TYPES.Requisition
													? true
													: $scope.vm.viewPurchaseOrder.printVendorCopy,
											Copy2: $scope.vm.viewPurchaseOrder.printCopyTwo,
											Copy3: $scope.vm.viewPurchaseOrder.printCopyThree,
										},
									];

									if (
										$scope.vm.filter.purchasingType !== PURCHASING_TYPES.Requisition &&
										!$scope.vm.viewPurchaseOrder.printVendorCopy &&
										!$scope.vm.viewPurchaseOrder.printCopyTwo &&
										!$scope.vm.viewPurchaseOrder.printCopyThree
									) {
										dialogHelper.openMessageBox(
											'No copies selected.',
											'Please select one or more copies to print.',
											null,
											'Warning'
										);
										$scope.loadingPromise = null;
										return;
									}

									var url = environment.API_URL + '/api/purchaseorder/printpos';

									// Load the PDF via AJAX request. This allows us to check if the request was successful.
									var xhr = new XMLHttpRequest();
									xhr.open('POST', url, true);
									xhr.responseType = 'blob';
									xhr.setRequestHeader('Authorization', authInterceptorService.bearerToken());
									xhr.setRequestHeader('Content-type', 'application/json');

									xhr.onload = function (oEvent) {
										if (xhr.status === 200) {
											let blob = new Blob([xhr.response], {
												type: 'application/pdf',
											});

											// IE (as of 11) doesn't allow window.open with Blobs, so we use their native method.
											if (window.navigator.msSaveOrOpenBlob) {
												window.navigator.msSaveOrOpenBlob(blob, 'PurchaseOrder.pdf');
											} else {
												let bloburl = URL.createObjectURL(blob);
												window.open(bloburl);
											}
											$scope.isReportFinished = true;
										} else {
											let msgList = [];
											if (xhr.status === 204) {
												msgList.push('No data available for this request!');
											} else {
												msgList.push('An error occurred during the request.');
												msgList.push('If the problem continues, please contact your Administrator!');
											}
											$scope.isReportFinished = true;
											dialogHelper.openMessageBox('Report Message', null, msgList, 'Warning');
										}
										modalInstance.close(true);
									};

									xhr.send(JSON.stringify(purchaseOrderToPrint));
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					$scope.vm.viewPurchaseOrder.activeImage = 0;
					$scope.vm.viewPurchaseOrder.selectedCopyNumber = 1;
					$scope.vm.viewPurchaseOrder.printVendorCopy = false;
					$scope.vm.viewPurchaseOrder.printCopyTwo = false;
					$scope.vm.viewPurchaseOrder.printCopyThree = false;
					$scope.vm.viewPurchaseOrder.emailVendorCopy = false;
					$scope.vm.viewPurchaseOrder.emailReceiptCopy = false;

					if (reload) {
						$scope.loadingPromise = $scope.vm.loadPurchaseOrders();
					}
				});
		}

		function loadNumberOfCopies(model) {
			if (!model.siteAccounting) {
				return purchaseOrderSetupService.getBySiteId(null).toPromise().then(finishedLoadingPOSetup);
			}

			function finishedLoadingPOSetup(response) {
				model.numberOfCopies = 1;
				if (response) {
					model.numberOfCopies = response.NumberOfCopies;
				}
			}
		}

		function loadPurchaseOrders(model) {
			model.reloadFilters();
			if (model.filter.purchasingType === PURCHASING_TYPES.Requisition) {
				return purchaseOrderService.getRequisitions().then(_.partial(finishLoadingPurchaseOrders, model));
			}
			return purchaseOrderService.getPurchaseOrders().then(_.partial(finishLoadingPurchaseOrders, model));

			function finishLoadingPurchaseOrders(model, response) {
				model.purchaseOrders = response.data.purchaseOrders;

				for (var index = 0; index < model.purchaseOrders.length; index++) {
					if (
						model.purchaseOrders[index].Status !== model.statusEnum.Sent &&
						(model.filter.purchasingType === PURCHASING_TYPES.PurchaseOrder ||
							model.purchaseOrders[index].DeliveryMethod === model.deliveryMethodEnum.Print)
					) {
						model.purchaseOrders[index].Selected = true;
					} else {
						model.purchaseOrders[index].Selected = false;
					}
				}

				return angular.noop;
			}
		}

		function reloadPOReqs() {
			$scope.loadingPromise = $q.all([$scope.vm.loadPurchaseOrders($scope.vm)]);
		}

		function reloadFilters() {
			$scope.vm.deliveryMethods = [];
			$scope.vm.statusList = [
				{ id: 'Not Printed/Emailed', description: 'Not Printed/Emailed' },
				{ id: 'Printed/Emailed', description: 'Printed/Emailed' },
			];
			$scope.vm.filter.status = 'Not Printed/Emailed';

			$scope.vm.deliveryMethods.push($scope.vm.deliveryMethodEnum.All);
			$scope.vm.deliveryMethods.push($scope.vm.deliveryMethodEnum.Print);
			$scope.vm.deliveryMethods.push($scope.vm.deliveryMethodEnum.Email);
			$scope.vm.filter.deliveryMethod = 'All';
		}

		function selectAllPurchaseOrders(model) {
			var setValue;
			if (model.filter.allSelected) {
				setValue = false;
			} else {
				setValue = true;
			}

			model.filter.allSelected = setValue;

			for (var index = 0; index < model.filteredPurchaseOrders.length; index++) {
				if (
					model.filteredPurchaseOrders[index].Status === model.statusEnum.AwaitingSend &&
					(model.filter.purchasingType === PURCHASING_TYPES.PurchaseOrder ||
						model.filteredPurchaseOrders[index].DeliveryMethod === model.deliveryMethodEnum.Print)
				) {
					model.filteredPurchaseOrders[index].Selected = setValue;
				}
			}
		}

		function confirmSendPurchaseOrders(model) {
			model.errors = '';
			model.confirmPrintError = null;
			model.confirmEmailError = null;

			if (model.siteAccounting) {
				// set numberOfCopies based on setup of selected PO sites
				var numberOfCopies = model.filteredPurchaseOrders.map(function (item) {
					return item.SiteNumberOfCopies;
				});
				model.numberOfCopies = _.max(numberOfCopies);
			}

			$uibModal.open({
				template: require('@ajs/templates/fund/payable/purchaseorder-confirmsend-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					function ($scope, modalInstance) {
						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							send: function () {
								model.confirmPrintError = null;
								model.confirmEmailError = null;
								if (model.filter.numberOfSelectedItemsPrint > 0 && model.filter.purchasingType !== PURCHASING_TYPES.Requisition) {
									if (!(model.printVendorCopy || model.printCopyTwo || model.printCopyThree)) {
										model.confirmPrintError = 'Select at least one copy to print.';
									}
								}
								if (model.filter.numberOfSelectedItemsEmail > 0) {
									if (!(model.emailVendorCopy || model.emailReceiptCopy)) {
										model.confirmEmailError = 'Select at least one copy to email.';
									}
								}

								if (model.confirmPrintError || model.confirmEmailError) {
									return;
								}
								modalInstance.close();
								model.sendSelected();
							},
						});
					},
				],
			});
		}

		function sendSelected(model) {
			model.errors = '';
			// Send the emails.
			var purchaseOrdersToSend = [];
			var purchaseOrdersToPrint = [];
			for (var index = 0; index < model.filteredPurchaseOrders.length; index++) {
				var filteredPO = model.filteredPurchaseOrders[index];
				if (filteredPO.Selected) {
					var po = {
						Id: filteredPO.Id,
						SiteId: filteredPO.SiteId,
					};

					if (filteredPO.DeliveryMethod === model.deliveryMethodEnum.Email) {
						po.SendType = 'Email';
						po.Copy1 = $scope.vm.emailVendorCopy;
						po.Copy2 = $scope.vm.emailReceiptCopy;
						purchaseOrdersToSend.push(po);
					} else {
						po.SendType = 'Print';
						po.Copy1 = model.filter.purchasingType === PURCHASING_TYPES.Requisition ? true : $scope.vm.printVendorCopy;
						po.Copy2 = $scope.vm.printCopyTwo;
						po.Copy3 = $scope.vm.printCopyThree;
						if (model.siteAccounting) {
							// if po setup is per site then make sure the site is setup for the right number of copies
							po.Copy2 = po.Copy2 && filteredPO.SiteNumberOfCopies > 1;
							po.Copy3 = po.Copy3 && filteredPO.SiteNumberOfCopies > 2;
						}
						purchaseOrdersToPrint.push(po);
					}
				}
			}

			if (purchaseOrdersToSend.length > 0) {
				if (!$scope.vm.emailVendorCopy && !$scope.vm.emailReceiptCopy) {
					return;
				}

				$scope.loadingPromise = purchaseOrderService.emailPurchaseOrder(purchaseOrdersToSend).then(_.partial(openPrintablePos, model));
			} else {
				if ($scope.vm.filter.purchasingType !== PURCHASING_TYPES.Requisition) {
					if (!$scope.vm.printVendorCopy && !$scope.vm.printCopyTwo && !$scope.vm.printCopyThree) {
						return;
					}
				}

				openPrintablePos();
			}

			function openPrintablePos() {
				// Then open the printable POs.
				if (purchaseOrdersToPrint.length === 0) {
					model.displaySendStatus(purchaseOrdersToPrint.concat(purchaseOrdersToSend));
					model.loadPurchaseOrders();
				} else {
					$scope.isReportFinished = false;
					$scope.loadingPromise = $scope.reportInterval = $interval(function () {
						if ($scope.isReportFinished) {
							$interval.cancel($scope.reportInterval);
							$scope.isReportFinished = false;
						}
					}, 1000);

					var url = environment.API_URL + '/api/purchaseorder/printpos';

					// Load the PDF via AJAX request. This allows us to check if the request was successful.
					var xhr = new XMLHttpRequest();
					xhr.open('POST', url, true);
					xhr.responseType = 'blob';
					xhr.setRequestHeader('Authorization', authInterceptorService.bearerToken());
					xhr.setRequestHeader('Content-type', 'application/json');

					xhr.onload = function (oEvent) {
						if (xhr.status === 200) {
							let blob = new Blob([xhr.response], { type: 'application/pdf' });

							// IE (as of 11) doesn't allow window.open with Blobs, so we use their native method.
							if (window.navigator.msSaveOrOpenBlob) {
								window.navigator.msSaveOrOpenBlob(blob, 'PurchaseOrder.pdf');
							} else {
								let bloburl = URL.createObjectURL(blob);
								window.open(bloburl);
							}
							$scope.isReportFinished = true;
							model.displaySendStatus(purchaseOrdersToPrint.concat(purchaseOrdersToSend));
							model.loadPurchaseOrders();
						} else {
							let msgList = [];
							if (xhr.status === 204) {
								msgList.push('No data available for this request!');
							} else {
								msgList.push('An error occurred during the request.');
								msgList.push('If the problem continues, please contact your Administrator!');
							}
							$scope.isReportFinished = true;
							dialogHelper.openMessageBox('Report Message', null, msgList, 'Warning');
						}
					};

					xhr.send(JSON.stringify(purchaseOrdersToPrint));
				}
			}
		}

		function displaySendStatus(model, purchaseOrdersToSend) {
			purchaseOrderService.checkPurchaseOrderStatus(purchaseOrdersToSend).then(_.partial(doneCheckingStatus, model));

			function doneCheckingStatus(model, response) {
				model.sendStatus = response.data.failures;
				model.sendStatusEmailsFailed = model.sendStatus.filter(function (value) {
					return value.DeliveryMethod === model.deliveryMethodEnum.Email;
				}).length;

				model.sendStatusPrintsFailed = model.sendStatus.filter(function (value) {
					return value.DeliveryMethod === model.deliveryMethodEnum.Print;
				}).length;

				$uibModal.open({
					template: require('@ajs/templates/fund/payable/purchaseorder-sendsummary-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							angular.extend($scope, {
								done: function () {
									modalInstance.close();
								},
							});
						},
					],
				});
			}
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		return angular.extend(model, {
			loadNumberOfCopies: _.partial(loadNumberOfCopies, model),
			loadPurchaseOrders: _.partial(loadPurchaseOrders, model),
			reloadPOReqs: reloadPOReqs,
			reloadFilters: reloadFilters,
			selectAllPurchaseOrders: _.partial(selectAllPurchaseOrders, model),
			sendSelected: _.partial(sendSelected, model),
			openPuchaseOrder: _.partial(openPuchaseOrder, model),
			filterPurchaseOrders: _.partial(filterPurchaseOrders, model),
			confirmSendPurchaseOrders: _.partial(confirmSendPurchaseOrders, model),
			displaySendStatus: _.partial(displaySendStatus, model),
			sortby: _.partial(sortby, model),
		});
	}
}
